import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query. Effect only re-runs when `query` changes.
 */
export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mediaMatch = window.matchMedia(query);
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mediaMatch.matches);

    if (typeof mediaMatch.addEventListener === 'function') {
      mediaMatch.addEventListener('change', handler);
      return () => mediaMatch.removeEventListener('change', handler);
    }

    // Safari < 14
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  }, [query]);

  return matches;
};
